import experienceTagStore from '@store/experience-tag-store.ts';
import compoundThumbnailStore from '@store/compound-thumbnail-store.ts';
import authStore from '@store/auth-store.ts';
import { UserRole } from '@/schemas/user-schema.ts';
import usersStore from '@store/users-store.ts';

export async function ExperienceTagsLoader() {
	if (!experienceTagStore.initialized) {
		await experienceTagStore.waitForInit();
	} else {
		void experienceTagStore.loadExperienceTags();
	}

	const experienceTags = experienceTagStore.experienceTags;
	void compoundThumbnailStore.compoundTagThumbnails(experienceTags);

	if (authStore.haveUserRole(UserRole.ADMIN)) {
		void usersStore.loadUsers();
	}

	return experienceTags;
}
